import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

StructuredData.propTypes = {
  data: PropTypes.object.isRequired,
};

// Helper functions for common structured data types
export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'The Dog Share Collective',
  url: 'https://www.thedogsharecollective.com',
  logo: 'https://www.thedogsharecollective.com/images/tdsc-share.png',
  description: 'Connect dog owners with dog lovers for walking, playdates, and companionship.',
  sameAs: [
    'https://www.facebook.com/DogShareCollective',
    'https://www.instagram.com/dogsharecollective/',
  ],
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'NZ',
    addressRegion: 'New Zealand',
  },
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.thedogsharecollective.com',
  name: 'The Dog Share Collective',
  description: 'Find local dogs to walk, play with, and share companionship.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.thedogsharecollective.com/find?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export const faqSchema = questions => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: questions.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
});

export const breadcrumbSchema = items => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export default StructuredData;



// WEBPACK FOOTER //
// ./src/components/StructuredData/index.js